import { Component, OnInit ,ChangeDetectorRef} from '@angular/core';
import { NewRelicService } from '../../../../../../angular-app/projects/brokerage-eapp/src/app/services/newrelic.service';
import { Router } from '@angular/router';
import { get, isArray } from 'lodash';

// services
import { NavigationService } from '../services/navigation.service';
import { ApiService } from 'src/app/services/api.service';

// App State
import { Store } from '@ngrx/store';
import { Observable, interval } from 'rxjs';
import { startWith, mergeMap, switchMap, takeWhile, first, take  } from 'rxjs/operators';
import { AppState, UPDATE_DECISION_INFO } from '../app-reducer';
import { TryCatchStmt } from '@angular/compiler';
import * as luxon from 'luxon';
import { CommonService } from '../services/common.service';
@Component({
  selector: 'processing-external',
  templateUrl: './processing-external.component.html'
})

export class ProcessingExternalComponent implements OnInit {
  appState$: Observable<any>;
  processing: boolean;
  appID;
  appAuthID;
  productName;
  counter;
  internalInterval: any;
  timeout: number = 7 * 60;
  timeLeft: number = 7 * 60;
  isDemo = false;
  thankYouPage='thank-you';

  constructor(
    private newRelicService: NewRelicService,
    public router: Router,
    private apiService: ApiService,
    private store: Store<AppState>,
    private navigationService: NavigationService,
    private changeDetection: ChangeDetectorRef,
    private commonService: CommonService
  ) {
    this.appState$ = this.store.select('sections');
    this.processing = false;
  }

  ngOnInit() {
    this.newRelicService.addPageAction('ngOnInit Start', { status: 'started' });

    this.processing = true;

    let data;

    // get latest state
    this.appState$.pipe(
      first()
    ).subscribe((state: any) => {
      try {
        this.appID = state['appId'];
        this.appAuthID =  state['appAuthId'];
        this.productName =  state['content']['SECTIONDCoverageDetails']['ProductName'];
        this.isDemo = state.isDemo;

        this.newRelicService.addPageAction('State Retrieved', { appId: this.appID });

      } catch (e) {
        this.newRelicService.noticeError(e, { appId: this.appID });
        console.log('ERROR: ', e);
      }

      // generate policy number if not simulating
      data = {
        'appID': this.appID,
        'productName': this.productName
      };

      console.log('Policy Number assignment');
      // generate policy number
      // this.generatePolicyNumber(data);
      this.pollPolicyNumber(data);
    });

    this.newRelicService.addPageAction('ngOnInit End', { status: 'completed' });
  }

  pollPolicyNumber(data) {
    this.newRelicService.addPageAction('pollPolicyNumber Start', { status: 'started', appId: this.appID });

    this.startDecisionTimer();

    // poll final decision
    console.log('getting policy number');
    this.apiService.generatePolicyNumber(data).subscribe((response: any) => {
      this.newRelicService.addPageAction('Pol Num API Call Success', { status: 'success', appId: this.appID });

      // get decision and hard failure check
      const policyNumber = get(response, 'data.details.policyNumber');         
      const processAppPayload = {
        AppId: this.appID,
        AppAuthId: this.appAuthID,
        PolicyNumber: policyNumber
      };

      this.apiService.processApplication(processAppPayload).subscribe(res => {
        console.log(res);
        this.pauseDecisionTimer();
        this.goToThankYou();
      }, (error) => {
        this.newRelicService.noticeError(error, { appId: this.appID });
        console.log('ERROR');
        console.log(error);
      });

      if (this.timeLeft <= 0) {
        this.pauseDecisionTimer();
        this.goToThankYou();
      }
      return response;
    }, (error) => {
      this.newRelicService.noticeError(error, { appId: this.appID });
      console.log('ERROR');
      console.log(error);
    });

    this.newRelicService.addPageAction('pollPolicyNumber End', { status: 'completed', appId: this.appID });
  }

  startDecisionTimer() {
    this.newRelicService.addPageAction('startDecisionTimer Start', { status: 'started', appId: this.appID });

    console.log('Decision Timer :', luxon.DateTime.now().toFormat('hh:mm:ss').toString());
    clearInterval(this.internalInterval);
    this.timeLeft = this.timeout;

    this.internalInterval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
        this.counter=this.commonService.toMMSS((this.timeout - this.timeLeft));
        this.changeDetection.detectChanges(); 
      }
      if (this.timeLeft == 0) {
        this.goToThankYou();
        this.pauseDecisionTimer();
      }
    }, 1000);

    this.newRelicService.addPageAction('startDecisionTimer End', { status: 'completed', appId: this.appID });
  }

  pauseDecisionTimer() {
    clearInterval(this.internalInterval);
    this.timeLeft = 0;
  }

  goToThankYou() {
    this.newRelicService.addPageAction('goToThankYou', { status: 'navigating', appId: this.appID });
    this.navigationService.nextSectionRelative(this.thankYouPage);
  }
}